import styled, { css } from 'styled-components';

const ComparePlansAccordionStyled = styled.section.attrs({
  className: 'accordion',
})`
  ${({ theme, active }) => {
    const { colors, fonts } = theme;
    return css`
      background-color: ${colors.primary.white};
      position: relative;
      .accordion {
        &__header {
          display: flex;
          padding: 16px;
          align-items: center;
          align-self: stretch;
          background: ${colors.primary.neutralLight};
          cursor: pointer;
        }
        &__title-container {
          display: flex;
          align-items: center;
          flex: 1 1 auto;
          font-weight: 800;
          gap: 8px;
        }
        &__title {
          color: ${colors.primary.gravity};
          font-family: ${fonts.objectSans};
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
        }
        &__icon {
          width: 16px;
          height: 16px;
          font-weight: 100;
        }
        &__content {
          overflow: ${active ? 'visible' : 'hidden'};
        }
      }
    `;
  }}
`;

export default ComparePlansAccordionStyled;
